import { render, staticRenderFns } from "./IawyerInformation.vue?vue&type=template&id=48acd872&scoped=true&"
import script from "./IawyerInformation.vue?vue&type=script&lang=js&"
export * from "./IawyerInformation.vue?vue&type=script&lang=js&"
import style0 from "./IawyerInformation.vue?vue&type=style&index=0&id=48acd872&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acd872",
  null
  
)

export default component.exports